/* ─── Root ─── */

.root {
  display: flex;
  align-items: center;
  gap: var(--space-1);
}

.root[data-orientation="vertical"] {
  flex-direction: column;
}

/* ─── Separator ─── */

.separator {
  background: var(--md-outline-variant);
  flex-shrink: 0;
}

.root:not([data-orientation="vertical"]) .separator {
  width: 1px;
  height: 1.5rem;
  margin: 0 var(--space-1);
}

.root[data-orientation="vertical"] .separator {
  height: 1px;
  width: 100%;
  margin: var(--space-1) 0;
}
